<template>
  <Navbar homepage logourl="/rental" />
  <section id="regulationsSection">
    <div class="container pt-5">
      <div class="section-caption">
        <h2>REGULAMIN</h2>
      </div>
      <div class="tile">
        <div style="display: flex; justify-content: flex-end; margin-bottom: 2em" v-if="printButton || iUser">
          <button type="button" class="btn btn-sm btn-primary" @click="save2Pdf(false)">Wygeneruj PDF</button>
        </div>
        <div class="section-content" id="printArea">
          <div class="text-center">
            <h5>REGULAMIN ŚWIADCZENIA USŁUGI „TESTER NA WYNAJEM”</h5>

            <ol class="ol-1" style="text-align: justify">
              <li>
                Niniejszy regulamin <b>– dalej Regulamin</b>, określa warunki świadczenia usługi „Tester na wynajem” <b>– dalej Usługa</b>.
                W skład Usługi wchodzi udzielanie niewyłącznej, czasowej licencji na korzystanie z oprogramowania służącego
                do profesjonalnej diagnostyki samochodów (wraz z bieżącymi aktualizacjami) <b>– dalej Oprogramowanie</b>
                oraz dzierżawa urządzenia diagnostycznego (wraz z przewodem USB oraz adapterem J1962) <b>– dalej Urządzenie</b>.
                W okresie świadczenia Usługi aktualizacje będą udostępniane drogą elektroniczną.
              </li>
              <li>
                Oprogramowanie i Urządzenie stanowią własność Axes&nbsp;System&nbsp;sp.&nbsp;z&nbsp;o.&nbsp;o. z siedzibą w Gdańsku&nbsp;(80-215),&nbsp;ul.&nbsp;Raciborskiego&nbsp;35,
                wpisaną do Krajowego Rejestru Sądowego – Rejestru Przedsiębiorców pod numerem KRS&nbsp;444422 <b>– dalej Usługodawca</b>.
              </li>
              <li>
                Usługa jest świadczona wyłącznie na rzecz osób fizycznych, osób prawnych lub jednostek organizacyjnych niebędących osobami
                prawnymi, które wykorzystują Usługę bezpośrednio na potrzeby swojej działalności gospodarczej lub zawodowej, z wyłączeniem
                konsumentów <b>– dalej Usługobiorca</b>.
              </li>
              <li>
                Warunkiem korzystania z Oprogramowania jest dostęp do Internetu oraz posiadanie komputera z systemem operacyjnym Windows&nbsp;10
                lub nowszym. Oprogramowanie jest dostępne na stronie internetowej Usługodawcy do pobrania i zainstalowania na
                własnym komputerze.
              </li>
              <li>
                W okresie świadczenia Usługi Usługobiorca nabywa prawo do:
                <ol class="ol-2">
                  <li>telefonicznego wsparcia technicznego w zakresie instalacji, konfiguracji, obsługi i działania Urządzenia i Oprogramowania,</li>
                  <li>ekspresowego serwisu Urządzenia.</li>
                </ol>
              </li>
              <li>
                W przypadku zakwalifikowania Urządzenia do serwisu przez Usługodawcę, wymienia on niezwłocznie Urządzenie na sprawne na
                następujących zasadach:
                <ol class="ol-2">
                  <li>
                    Usługodawca na własny koszt wysyła na adres Usługobiorcy inne, sprawne Urządzenie najpóźniej w dniu roboczym następującym
                    po dniu zgłoszenia;
                  </li>
                  <li>
                    Usługobiorca na własny koszt wysyła na adres Usługodawcy dotychczas posiadane Urządzenie, w terminie do&nbsp;7&nbsp;dni licząc
                    od dnia następującego po dniu zgłoszenia;
                  </li>
                  <li>
                    do dni roboczych nie wlicza się dni, w których biuro Usługodawcy jest nieczynne, o czym Usługobiorca jest informowany
                    w momencie zgłoszenia.
                  </li>
                  <li>
                    w przypadku stwierdzenia, że Urządzenie odesłane Usługodawcy jest sprawne lub gdy usterka wynikła z winy Usługobiorcy,
                    Usługodawca zastrzega sobie prawo obciążenia Usługobiorcy kosztami wysyłki oraz naprawy zgodnie z cennikiem
                    opublikowanym na stronie internetowej Usługodawcy.
                  </li>
                </ol>
              </li>
              <li>
                Warunkiem rozpoczęcia świadczenia Usługi po raz pierwszy jest:
                <ol class="ol-2">
                  <li>
                    założenie konta Usługobiorcy na stronie internetowej Usługodawcy,
                    co jest równoznaczne z akceptacją niniejszego Regulaminu. Usługobiorca, akceptując niniejszy Regulamin, wyraża zgodę na:
                    <ol class="ol-3">
                      <li>otrzymywanie faktur w formie elektronicznej, zgodnie z obowiązującymi przepisami prawa,</li>
                      <li>przesyłanie drogą elektroniczną korespondencji, dotyczącej aktualizacji oprogramowania oraz usług związanych z abonamentem;</li>
                    </ol>
                  </li>
                  <li>
                    złożenie zamówienia i dokonanie pierwszej płatności na rachunek bankowy Usługodawcy bezpośrednio z rachunku bankowego Usługobiorcy w taki sposób, aby dane nadawcy przelewu były zgodne z danymi Usługobiorcy podanymi w zamówieniu. Na kwotę płatności składa się opłata aktywacyjna
                    w kwocie 99&nbsp;złotych&nbsp;netto oraz kwota wynikająca ze wskazanego w zamówieniu okresu świadczenia Usługi. Podane kwoty netto zostaną powiększone o podatek VAT.
                  </li>
                </ol>
              </li>
              <li>
                Umowa o świadczenie Usługi jest zawierana na czas określony wskazany w zamówieniu Usługi. Usługobiorca ma możliwość
                wynajmu urządzenia na okres minimum jednego miesiąca lub jego wielokrotności. Usługa wygasa z chwilą upływu tego czasu, o
                ile w okresie obowiązywania umowy Usługobiorca nie dokona jej przedłużenia poprzez dokonanie zapłaty za kolejny, wybrany
                przez siebie okres. Za moment zapłaty uznaje się moment wykonania płatności w przypadku skorzystania z pośrednictwa
                systemu „Przelewy&nbsp;24” lub moment zaksięgowania wpłaty na rachunku Usługodawcy w pozostałych przypadkach.
              </li>
              <li>
                Z chwilą wygaśnięcia Usługi dalsze korzystanie z Oprogramowania i Urządzenia jest niemożliwe. W takim wypadku Usługobiorca
                zobowiązuje się w terminie 7 dni zwrócić Urządzenie na własny koszt na adres Usługodawcy, w stanie nie pogorszonym ponad
                normalne zużycie, czyste i sprawne. W przypadku zwrócenia Urządzenia uszkodzonego z winy Usługobiorcy, Usługodawca zastrzega
                sobie prawo obciążenia Usługobiorcy kosztami naprawy zgodnie z cennikiem opublikowanym na stronie internetowej
                Usługodawcy. W wypadku niezwrócenia Urządzenia w terminie, Usługobiorca zobowiązuje się do zapłaty kary umownej w wysokości
                50&nbsp;złotych&nbsp;netto za każdy dzień opóźnienia, lecz nie więcej niż 5000&nbsp;złotych&nbsp;netto w sumie. Podane kwoty netto zostaną
                powiększone o podatek VAT.
              </li>
              <li>
                Usługobiorca ponosi odpowiedzialność za ryzyko utraty Urządzenia od momentu wydania go aż do jego zwrotu. Usługobiorca
                zobowiązuje się także do zapłaty ceny w wysokości 5000&nbsp;złotych&nbsp;netto w wypadku jego zniszczenia lub utraty. Podana kwota
                netto zostanie powiększona o podatek VAT.
              </li>
              <li>
                Administratorem danych osobowych jest Usługodawca. Dane Usługobiorcy będą przetwarzane celem wykonania umowy i kontaktu
                z Klientem. Przetwarzanie odbywa się w oparciu o art.&nbsp;6&nbsp;ust.&nbsp;1&nbsp;b&nbsp;i&nbsp;f&nbsp;RODO. Twoje dane mogą zostać przez nas powierzone
                podmiotom, z których usług korzystamy przy prowadzeniu działalności, w tym podmiotom świadczącym usługi z zakresu IT, marketingu,
                obsługi prawnej, logistyki a także organom publicznym w sytuacji, kiedy prawo tego wymaga.
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Stopka -->
  <Footer />
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import jsPDF from "jspdf";
import html2pdf from "html2pdf.js";
import {makeRequest} from "@/utils/helpers";
import {RequestResult} from "@/utils/requestResult";

export default {
  name: "RegulationsView",
  components: {Footer, Navbar},
  data() {
    return {
      iUser: false,
      printButton: false
    }
  },

  async created() {
    await this.isIUser();
  },
  mounted() {
    const action = this.$route.query.action;

    if (action === 'printpdf') {
      this.printButton = true;
      this.save2Pdf(true);
    }
  },

  methods: {
    save2Pdf(sendToPrint) {
      //wykorzystano: https://www.npmjs.com/package/html2pdf.js/v/0.10.3
      //alternatywa, ale znacznie bardziej skomplikowana: https://www.npmjs.com/package/jspdf
      //kolejna alternatywa: wysłać html do API, a API skorzysta z generatora PDF w HWS (DOMPdf)

      const originalElement = document.getElementById('printArea');
      const element = originalElement.cloneNode(true);

      //dodajemy miejsce na podpis/akceptację warunków regulaminu
      const extraHTML = `
      <div>
        <div style="text-align: left; margin-bottom: 1em; margin-top: 3em">
          <b>Oświadczam, że zapoznałem się z treścią Regulaminu i w całości go akceptuję.</b>
        </div>
        <div class="mb-3 row">
          <label for="inputSignature" class="col-sm-4 col-form-label">Data i czytelny podpis Usługobiorcy:</label>
          <div class="col-sm">
            <input type="text" class="form-control" style="border: 1px solid #000 !important; background-color: #fff !important; color: #000 !important;" id="inputSignature">
          </div>
        </div>
      </div>
    `;
      element.insertAdjacentHTML('beforeend', extraHTML);

      //stwórz tymczasowy kontener, aby nie modyfikować istniejącego
      const container = document.createElement('div');
      container.style.position = 'fixed';
      container.style.top = '-9999px'; //poza ekranem
      container.appendChild(element);
      document.body.appendChild(container);

      element.style.transform = 'scale(0.8)';
      element.style.transformOrigin = 'top left';
      element.style.width = '794px'; //szerokość A4 w px
      element.style.fontSize = '12px';

      const opt = {
        margin:       15,
        filename:     'regulamin.pdf',
        image:        { type: 'jpg', quality: 0.98 },
        html2canvas:  { scale: 3, width: 660, windowWidth: 794, logging: false },
        jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait'},
        pagebreak:    { mode: ['disable']}
      };

      html2pdf().set(opt).from(element).toPdf().get('pdf').then(pdf => {
        //usuń tymczasowy kontener po zapisaniu
        document.body.removeChild(container);
        /**
         * uwaga! aktualnie, mimo że kontent mieści się na jednej stronie dokumentu pdf, generowana jest druga, pusta strona;
         * być może to błąd w bibliotece, a być może kwestia ustawień CSS i konfiguracji;
         * w ramach *tymczasowego rozwiązania* usuwamy ostatnią stronę;
         * **/
        const totalPages = pdf.internal.getNumberOfPages();
        pdf.deletePage(totalPages); //usuwa ostatnią stronę

        if (sendToPrint)
        {
          const blobUrl = URL.createObjectURL(pdf.output("blob"));
          const iframe = document.createElement("iframe");
          iframe.style.display = "none";
          iframe.src = blobUrl;
          document.body.appendChild(iframe);
          iframe.onload = () => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
          };
        }
        else
        {
          pdf.save(opt.filename);
        }

      });
    },

    async isIUser() {

      let data = {
        action: this.request.IsIUser,
      };

      let getUserResponse = await makeRequest(data);

      switch (getUserResponse.data.error) {
        case RequestResult.OK: {
          this.iUser = true;
          break;
        }
      }

    }

  }
}


</script>


<style scoped>
  ol.ol-1, ol.ol-2, ol.ol-3 { list-style: none; margin-left: 1em; margin-right: 1em; padding-left: 0em }

  /* ---------- Punktory listy numerowanej - poziom 1 - 1. 2. 3. ---------- */
  ol.ol-1 { counter-reset: lvl1; }
  ol.ol-1 > li { counter-increment: lvl1; position: relative; padding-left: 2.2em; }
  ol.ol-1 > li::before {
    content: counter(lvl1) ". ";
    position: absolute; left: 0; width: calc(2.2em - .4em); text-align: right;
  }

  /* ---------- Punktory listy numerowanej - poziom 2 - 1) 2) 3) ---------- */
  ol.ol-2 { counter-reset: lvl2; margin-top: .3em; }
  ol.ol-2 > li { counter-increment: lvl2; position: relative; padding-left: 2.2em; }
  ol.ol-2 > li::before {
    content: counter(lvl2) ") ";
    position: absolute; left: 0; width: calc(2.2em - .4em); text-align: right;
  }

  /* ---------- Punktory listy numerowanej - poziom 3 - a) b) c) ---------- */
  ol.ol-3 { counter-reset: lvl3; margin-top: .2em; }
  ol.ol-3 > li { counter-increment: lvl3; position: relative; padding-left: 2.2em; }
  ol.ol-3 > li::before {
    content: counter(lvl3, lower-alpha) ") ";
    position: absolute; left: 0; width: calc(2.2em - .4em); text-align: right;
  }

  body { font-family: system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif; line-height: 1.5; padding: 24px; }
  li { margin: .2em 0; }

</style>